import SrSwitch from "./SrSwitch.vue";

SrSwitch.install = function(Vue) {
  Vue.component(SrSwitch.name, SrSwitch);
};

export default SrSwitch;


// WEBPACK FOOTER //
// ./packages/SrSwitch/index.js